import { useState,useEffect } from 'react';
import Downloader from "components/Downloader";
import Layout from "app/(others)/layout";
import "../../styles/styles.css";
import Page404 from "app/not-found";
import axios from "axios";


const API_URL = "https://ahuncycle-backend.vercel.app";
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageMerci = () => {
    const [ip, setIp] = useState("false");
/*
    const getIp = async() => {
        try 
        {
            const responseLocation = await fetch('https://geolocation-db.com/json/');
            const data = await responseLocation.json();
            console.log("IP client:"+data.IPv4);
            return await data.IPv4;
        }
        catch (error) 
        {
          console.error("Erreur de payment:", error);
          return;
        }
    }

    const confirmation = async () => {
        const ip = await getIp();
        const response = await axiosInstance.get("api/achat/confirmation/"+ip);
        //console.log("Response:" + response.data);
        setIp(response.data);
    }

    useEffect(() => {
        confirmation();
      }, []);

    if (ip=="true")
    { 
    */
        return ( 
            <Layout>
            <div className={`nc-PageArchiveAudio `}>
            <div className="centrer container">
                <table>
                    <tbody>
                        <tr>
                            <td>Merci pour votre don!<br></br><br></br></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </div>
            </Layout> 
        );
/*    }
    else
    {
        return(<Page404/>);
    }
        */
};
    
export default PageMerci;
    
